import { useQuery } from '@tanstack/react-query'
import {
  ExecutiveMetricsResponse,
  ContractDateToUse,
  GetMetricsRequest,
  GetMetricsRequestTimePeriod,
  RexApiContext,
} from '@urbanx/agx.rex.client'
import { useContext } from 'react'
import { toExclusiveDate } from 'utils/date'

export enum NetworkReportType {
  State = 'state',
  PartnershipLevel = 'partnershipLevel',
}

const useExecutiveGetNetworkMetrics = (
  networkReportType: NetworkReportType,
  contractDateToUse: ContractDateToUse,
  fromDate: string,
  toDateInclusive: string,
  timePeriod: GetMetricsRequestTimePeriod
) => {
  const rexClient = useContext(RexApiContext)

  const { data, isPending, isError } = useQuery<
    ExecutiveMetricsResponse | undefined
  >({
    queryKey: [
      networkReportType,
      contractDateToUse,
      fromDate,
      toDateInclusive,
      timePeriod,
    ],
    queryFn: async () => {
      const request: GetMetricsRequest = {
        contractDateToUse,
        fromDate,
        toDateExclusive: toExclusiveDate(toDateInclusive),
        timePeriod,
      }

      if (networkReportType === NetworkReportType.State) {
        return await rexClient.getNetworkStateMetrics(request)
      }
      if (networkReportType === NetworkReportType.PartnershipLevel) {
        return await rexClient.getNetworkPartnershipMetrics(request)
      }
    },
  })

  return {
    data,
    isPending,
    isError,
  }
}

export default useExecutiveGetNetworkMetrics
